export const getCarousel = () =>[
    {
        src: '/assets/carrusel/casa_de_la_cultura.png',
        alt:''
    },
    {
        src: '/assets/carrusel/slide_1.png',
        alt:''
    },
    {
        src: '/assets/carrusel/slide_2.png',
        alt:''
    },
    {
        src: '/assets/carrusel/slide_3.png',
        alt:''
    },

]